import { render, staticRenderFns } from "./VolunteerProfileNeedsSection.vue?vue&type=template&id=32ed797c&scoped=true"
import script from "./VolunteerProfileNeedsSection.vue?vue&type=script&lang=js"
export * from "./VolunteerProfileNeedsSection.vue?vue&type=script&lang=js"
import style0 from "./VolunteerProfileNeedsSection.vue?vue&type=style&index=0&id=32ed797c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ed797c",
  null
  
)

export default component.exports